//#region IMPORTS
import { EyeIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { itemWord } from "../../helpers/formatItemCount";
//#endregion

//#region INTERFACE
interface Props {
  clickHandler: () => void;
  itemCount: number;
}
//#endregion

// The items cell of the instore orders list: a pill showing "<eye> N items" that
// opens the order's item list in a modal. The count lives in the button, so the
// cell holds this one element.
//
// The modal itself is in InstoreOrdersContainer, not here: it needs the order lines
// from a detail fetch, and mounting one table per row would build that (heavy)
// table for every row in the list.
export default function InstoreOrdersTableRowActionItemsOverview({
  clickHandler,
  itemCount,
}: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();
  //#endregion

  //#region RENDER
  return (
    <button
      type="button"
      onClick={clickHandler}
      className="inline-flex items-center gap-x-1.5 rounded-full bg-sky-200 px-2 py-0.5 text-xs font-medium text-sky-900 hover:bg-sky-600 hover:text-white"
    >
      <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" />
      {/* Count prepended instead of passed to t() as `count`: that would trigger
          i18next pluralisation and look for keys we don't have. The word itself
          is singular for 1 ("1 item", not "1 items") — see formatItemCount. */}
      <span className="font-bold">{itemCount}</span>
      {itemWord(itemCount, t)}
    </button>
  );
  //#endregion
}
